import React, { useState } from "react";
import "../styles/Account.css";
import { useNavigate } from "react-router-dom";
import { API_ENDPOINTS } from "../config/api";

const Account = () => {
  const navigate = useNavigate();

  const [isLogin, setIsLogin] = useState(true);
  const toggleMode = () => setIsLogin(!isLogin);

  const API = API_ENDPOINTS.USER_LOGIN;

  // ================= HANDLE SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;

    const payload = {
      fullName: form.fullName?.value,
      email: form.email.value,
      password: form.password.value,
    };

    try {
      const res = await fetch(
        `${API}/${isLogin ? "login" : "register"}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        alert(data.message || "Authentication failed");
        return;
      }

      // SAVE AUTH DATA
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));

      // GO TO PROFILE
      navigate("/profile");

    } catch (err) {
      console.error("Auth Error:", err);
      alert("Server error. Please try again.");
    }
  };

  return (
    <div className="account-container">

      {/* LEFT SIDE */}
      <div className="account-left">

        {/* BACK TO HOME */}
        <button
          className="back-home-btn"
          onClick={() => navigate("/")}
        >
          🏠 Back to Home
        </button>

        <div className="auth-box">

          <h2 className="auth-title">
            {isLogin ? "Welcome Back" : "Create Account"}
          </h2>

          <p className="auth-subtitle">
            {isLogin
              ? "Login to continue your spiritual journey"
              : "Register to join the divine community"}
          </p>

          <form className="auth-form" onSubmit={handleSubmit}>

            {/* FULL NAME (REGISTER ONLY) */}
            {!isLogin && (
              <input
                type="text"
                name="fullName"
                placeholder="Full Name"
                className="auth-input"
                required
              />
            )}

            {/* EMAIL */}
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              className="auth-input"
              required
            />

            {/* PASSWORD */}
            <input
              type="password"
              name="password"
              placeholder="Password"
              className="auth-input"
              required
            />

            <button type="submit" className="auth-btn">
              {isLogin ? "Login" : "Register"}
            </button>

          </form>

          <p className="toggle-text">
            {isLogin
              ? "Don’t have an account?"
              : "Already have an account?"}

            <span onClick={toggleMode}>
              {isLogin ? " Register" : " Login"}
            </span>
          </p>

        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="account-right">

        <img
          src="/images/gallery/saibaba2.jpg"
          alt="Temple"
          className="right-image"
        />

        <div className="image-overlay">
          <h1>Sri Gnana Sai Baba</h1>
          <p>Faith • Devotion • Blessings</p>
        </div>

      </div>

    </div>
  );
};

export default Account;